import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import {
  createRadioLocation,
  editRadioLocation,
  loadRadioLocation,
  loadRadioLocations,
  removeRadioLocation,
} from '@sophocles/features/inventory/radioLocations/api';
import RadioLocationSchema from '@sophocles/features/inventory/radioLocations/schema';
import { normalize } from 'normalizr';

const radioLocationsAdapter = createEntityAdapter();

const slice = createSlice({
  name: 'radioLocations',
  initialState: radioLocationsAdapter.getInitialState({
    view: {
      search: null,
      page: 0,
      order: 'asc',
      orderBy: 'id',
    },
  }),
  reducers: {
    setPage(state, action) {
      state.view.page = action.payload;
    },
    setSearch(state, action) {
      state.view.search = action.payload;
    },
    setOrder(state, action) {
      state.view.order = action.payload;
    },
    setOrderBy(state, action) {
      state.view.orderBy = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(loadRadioLocations.fulfilled, (state, action) => {
        const { entities } = normalize(action.payload.results, [RadioLocationSchema]);
        radioLocationsAdapter.upsertMany(state, entities.radioLocations ?? {});
      })
      .addCase(loadRadioLocations.rejected, (state, action) => {})
      .addCase(loadRadioLocation.fulfilled, (state, action) => {
        const { entities, result } = normalize(action.payload, RadioLocationSchema);
        radioLocationsAdapter.upsertOne(state, entities.radioLocations[result]);
      })
      .addCase(loadRadioLocation.rejected, (state, action) => {})
      .addCase(createRadioLocation.fulfilled, (state, action) => {
        const { entities, result } = normalize(action.payload, RadioLocationSchema);
        radioLocationsAdapter.upsertOne(state, entities.radioLocations[result]);
      })
      .addCase(createRadioLocation.rejected, (state, action) => {})
      .addCase(editRadioLocation.fulfilled, (state, action) => {
        const { entities, result } = normalize(action.payload, RadioLocationSchema);
        radioLocationsAdapter.upsertOne(state, entities.radioLocations[result]);
      })
      .addCase(editRadioLocation.rejected, (state, action) => {})
      .addCase(removeRadioLocation.fulfilled, (state, action) => {
        radioLocationsAdapter.removeOne(state, action.payload);
      })
      .addCase(removeRadioLocation.rejected, (state, action) => {});
  },
});

export const selectRadioLocationEntities = state => state.radioLocations;

export const { selectById } = radioLocationsAdapter.getSelectors(selectRadioLocationEntities);

export const selectRadioLocation = id => state => selectById(state, id);

export const getRadioLocationsViewProperties = createSelector(selectRadioLocationEntities, state => state.view);

export const {
  setPage: setRadioLocationsPage,
  setSearch: setRadioLocationsSearch,
  setOrder: setRadioLocationsOrder,
  setOrderBy: setRadioLocationsOrderBy,
} = slice.actions;

const { reducer } = slice;
export default reducer;
